import React, { Fragment ,useContext, useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Style from 'style-it';
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Button from "@material-ui/core/Button";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import "./App.css";
import {columnsFilter} from './dataconfig/columnsGrids'

import {
  SHOW_TOOL_BAR,
  SHOW_LEFT_SIDE_BAR,
  SHOW_FOOTHER,  
  apiDataUrl,apiListUrl,apiSaveUrl, thisMock, apiRepUrl
} from './projConst';
import {main_data,main_data_empty,main_data_row_empty} from './api/mockData';
import {main_data2} from './api/mockdata2';
import {pick_data} from './api/mockDepend';
import {main_save_data} from './api/mockSaveData';
import {report} from './api/mockExcel';

import ShowAppHeader from "./Components/ShowAppHeader";
import ShowAppFooter from "./Components/ShowAppFooter";
import ShowAppToolbar from "./Components/ShowAppToolbar";
import ShowAppSidebar from "./Components/ShowAppSidebar";
import ShowGrid from "./Components/Lib/ShowGrid";
import ShowMasterGrid from "./Components/Lib/ShowMasterGrid";
import ShowTotal from "./Components/ShowTotal";
import ShowFilter from './Components/Lib/ShowFilter';
import FormGrid from "./Components/FormGrid";

import { DataServerContext } from "./Server/DataServerContext";
import { InfoWinContext } from "./infowindow/infowinContext";

import * as api from "./api/apiFunc";
import * as R from 'ramda'
import { shallowEqual, useDispatch,useSelector } from 'react-redux'
import {columnsMainData,columnsSubData
} from './dataconfig/columnsGrids'

import ShowAzureMap from "./Components/ShowAzureMap";

const useStyles = makeStyles(theme => ({
  responsPerson: {
    margin: theme.spacing(),
    height: 900,
    width: "auto"
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  apptitle: {
    display: 'flex',
    width: '100%'
  },
  apptab: {
    minWidth: '80% !important',
  },
  appinnertab: {
    marginTop: '-30px'
  },
  usertitle: {
    alignSelf: 'center'
  },
/*
  root: {
    margin: theme.spacing(),
    textAlign: "left"
  },*/
  content: {
    paddingLeft: -theme.spacing(5),
    textAlign: "center"
  },
  title: {
    paddingLeft: theme.spacing(3),
    textAlign: "left",
    color: "#000",
    backgroundColor: "#d9d9d9",
    fontSize: "75%",
    fontWeight: "bold",
    height: 5
  },
}));

const defaultTabKey = '1';

function App(props) {
  const classes = useStyles();
  const { curmessage, messageWin, alertWin, alertmessage, dialogWin,
    dialog, dialoganswer } = useContext(InfoWinContext);
  const { loading, getServerDataRedux,getServerData, dataserver } = useContext(DataServerContext);

  const { tree, db, argum, iconsApp, configApp, themeCss, globalCss } = props
  const dispatch = useDispatch();

  const [mainlist, SetMainList] = useState([]);
  const [sublist, SetSubList] = useState([]);
  const [originsublist, SetOriginSubList] = useState([]);
  const [minmaxper, setMinMaxPer] = useState({});
  

  const [mainfilter, SetMainFilter] = useState();
  const [totallist, SetTotalList] = useState([]);
  const [totaltable, SetTotalTable] = useState([]);
  const [pick, SetPick] = useState([]);

  const [scrollY, setScrollY] = useState(0);
  const [updatedData, SetUpdatedData] = useState([]);
  const [deleteData, SetDeleteData] = useState([]);
  const [insertData, SetInsertData] = useState([]);
  const [showFilter, SetShowFilter] = useState({ open: false, title: 'Фильтр по полям', mess: "" });
  const [curentRow, SetCurentRow] = useState({});
  const [curentSubRow, SetCurentSubRow] = useState({});

  const [newCoord, SetNewCoord] = useState({});
  const [fullmap, Setfullmap] = useState(false);
  const [fulltable, Setfulltable] = useState(false);
  const [subfilter, Setsubfilter] = useState(true);
  const [showAllMarcers, SetShowAllMarcers] = useState(true); 
  
  const [deselectgrid, Setdeselectgrid] = useState(false);
  const [autoclearFilter, SetAutoclearFilter] = useState(false);
  const [hide, SetHide] = useState(0);
  const [focus, SetFocus] = useState(true);

  const [datefilter, SetDateFilter] = useState(api.DatetoString(new Date()));
  //const [filter, SetFilter] = useState({
  //  activ: ["ПАО \"Запорожсталь\"\r\n"], napr: null, sostav: null, marshrut: null, stancprim: null, oper: null, date: null,
  const [filter, SetFilter] = useState({
      activ: null, napr: null, sostav: null, marshrut: null, stancprim: null, oper: null, date: null,
      nazvpol: null, nazvotpr: null, stdis: null, nazvgruza: null, dor: null, nomv: null,
    marsh: null, single: null, st: 1})
  const [curentIdxRow, SetCurentIdxRow] = useState(null);
  
  function logit() {
    setScrollY(window.pageYOffset);
  }  
  const maindata = useSelector(state=>state.maindata,shallowEqual)
  const listdata = useSelector(state => state.listdata, shallowEqual)
  
  
  useEffect(async () => {
    dispatch(getServerDataRedux(apiDataUrl, true, { datafilter: filter }, thisMock, main_data, 'FETCH_MAIN_DATA', main_data_empty))
    //console.log('window.screen', window.innerWidth, window.innerHeight)
    
    //dispatch(getServerDataRedux(apiListUrl, true, prepareParam(), thisMock, pick_data, 'FETCH_LIST_DATA'))
  }, []);

  /*useEffect(() => {
    if (showAllMarcers) {
      SetCurentRow({})
    }
  }, [showAllMarcers])*/

   useEffect(() => {
    if (api.isEmpty(maindata)) return
       SetMainList(maindata.serverdata.datamain);
       SetSubList(maindata.serverdata.subdata);
       SetOriginSubList(maindata.serverdata.subdata);
       setMinMaxPer(handleMinMax(maindata.serverdata.subdata))
       SetPick(maindata.serverdata.picklists);
       SetDateFilter(api.DatetoString(new Date()))
     
      //console.log('pick', maindata.serverdata.picklists)
      //console.log('rows',maindata.serverdata.subdata)
       SetMainFilter(maindata.serverdata.datafilter);
       //SetTotalList(api.SumTotalRow(maindata.serverdata.datamain));
       //SetTotalTable(maindata.serverdata.datatotal);
       //SetTotalTable(api.SumTotalVid(maindata.serverdata.datamain));
      }, [maindata]);

      useEffect(() => {
        if (!api.isNotEmptyArr(pick)) return
       //  handleFilterAnswer(true, {activ: ["ПАО \"Запорожсталь\"\r\n"], kodstdis: null, nazvstdis: null, nazvgruza: null, nomv: null, nazvpol: null,
       //   nazvotpr: null, napr: null, dor: null, st: 1}, false)
      }, [pick]);

  const prepareParam = (userarg=null) => {
    const { tree, db } = props
    const appParams = { tree, db };

    return userarg ? {appParams,...userarg} : {appParams}
  } 
  const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  const GetResultSrvDat = (data, action, is_error) => {
   if (is_error) return
     switch (action) {
       case "get_report":
          //var d = new Date();
          //application/octet-stream
          const blob = b64toBlob(data.body, "application/vnd.ms-excel");
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = data.name;
          link.click();
          break
     }
   }

  const handleColumnFilter = () => {
      SetShowFilter({open : true,title:'Фильтр по полям', mess : "" }) 
  }
  
  const handleSeek = (val,args) => {
    if (args.arg1 == "") {
      SetMainList(maindata.serverdata.datamain)
      return 
    }
    handleFilterAnswer(true, {activ: null, napr: null, sostav: null, marshrut: null, stancprim: null, oper: null, date: null,
    nazvpol: null, nazvotpr: null, stdis: null, nazvgruza: null, dor: null, nomv: null,
    marsh: null, single: null, st: 1
    },false,false)
    SetAutoclearFilter(true)
    const orig = maindata.serverdata.datamain
    const list = orig.filter(row => 
      row.StationCode.toString().indexOf(args.arg1) !== -1 ||
      row.StationName.toLowerCase().indexOf(args.arg1.toLowerCase()) !== -1 
    )
    SetMainList(list)
    const origin = maindata.serverdata.subdata
    SetSubList(origin.filter(el => SetSearch(el, list)))
    setMinMaxPer(handleMinMax(origin.filter(el => SetSearch(el, list))))

    Setdeselectgrid(!deselectgrid)
    if (api.isNotEmptyArr(list)) SetCurentRow({})
  }
  const FilterSearch = (row, list) => {
    return list.filter(el => el.StationCode == row.kodstdis)
  }
  const onHandleSave = (name,data) => {
    //props.SaveDict({ table: name, data })
  }
  

  const SetSearch = (row, data) => { 
    let filt = false
    data.map(m => (filt = row.kodstdis == m.StationCode ? true : filt  )) 
    return filt
  }
  
  const handleCurRow = (row) => { 
    SetCurentRow(row)
    if (maindata.serverdata.subdata == undefined) return
    const origin = maindata.serverdata.subdata
    /* if (subfilter == true) {
      let templist = [...origin.filter(el => el['kodstdis'] == row['StationCode'])]
      R.keys(mainfilter).map(key => {
        if (mainfilter[key] !== null)
          if (api.isNotEmptyArr(mainfilter[key]) && key !== 'date') {
            let arrfilter = []
            mainfilter[key].map(k => {
              let tmplist = templist.filter(row => {
                let res   
                if (typeof row[key] === 'number') {
                  if (key == 'napr') {
                    if (mainfilter[key].length == 2)
                      res = true
                    else {
                      if (mainfilter[key][0] == "Прием")
                        res = row[key] == 1
                      else
                        res = row[key] == 2
                    }
                  }
                  else
                  res = row[key] == Number(k)
                }
                if (typeof row[key] === 'string') 
                  res = row[key].toString().indexOf(k) !== -1
                  if (key == 'activ') {                 
                    const curList = R.find(R.propEq('name', 'Activ'))(pick).rows                  
                    let rowactiv = R.find(R.propEq('title', k))(curList)
                    const {pk_id} = rowactiv
                    const kodpol = pk_id
                    if (row['napr'] == 1)
                    res = (row['kodpol'] == kodpol)
                  else if (row['napr'] == 2)
                    res = (row['kodotpr'] == kodpol)
                  }
                  if (key == 'stancprim') {
                    const curList = R.find(R.propEq('name', 'stancPrim'))(pick).rows                  
                    let rowprim = R.find(R.propEq('title', k))(curList)
                    const {id} = rowprim
                    const kodstnazn = id
                    res = (row['kodstnazn'] == kodstnazn)
                  }
                if (key == 'stdis') {
                    const std = k.split(' ')
                    res = row['kodstdis'].toString().indexOf(std[0]) !== -1
                }
                if (key == 'sostav') {
                  const sostav = k.split(' ')
                  res = row['indp'].toString().indexOf(sostav[0]) !== -1
                }
                if (key == 'marshrut') {
                  const marsh = k.split(' ')
                  res = row['indp'].toString().indexOf(marsh[0]) !== -1
                }
                return (res)
              })
              arrfilter = [...arrfilter,...tmplist]
            })
            templist = [...arrfilter]
          }
        else
           templist = templist.filter(row => {
            let res   
            if (typeof row[key] === 'number') {
               res = row[key] == Number(mainfilter[key])
             } 
            if (typeof row[key] === 'string')
              res = row[key].toString().indexOf(mainfilter[key]) !== -1 
            if (key == 'st' && Number(mainfilter[key]) == 1) {
                res = CheckMainDataST(row,Number(mainfilter[key]))
            }
            if (key == 'date') {
              const k = mainfilter[key]
              res = new Date(row['datop']) > new Date(k[0]) && new Date(row['datop']) < new Date(k[1])
            }
            return (res)
          })
      })
      SetSubList(templist)
     }
    else */
      SetSubList(origin.filter(el => el['kodstdis'] == row['StationCode']))
      setMinMaxPer(handleMinMax(origin.filter(el => el['kodstdis'] == row['StationCode'])))

  }

  const handleSubCurRow = (row) => {
    SetCurentSubRow(row)
    const currow = mainlist.filter(el => el.StationCode == row.kodstdis)
    SetCurentRow(currow)
  }

  const handleGetReport = () => {
    const StationCode = !api.isEmpty(curentRow) && curentRow.StationCode ? curentRow.StationCode : null
    const datafilter = filter
    console.log('handleGetReport',{StationCode,datafilter})
    getServerData(apiRepUrl,prepareParam({StationCode,datafilter}),thisMock,report,GetResultSrvDat,null,false,null,null,'get_report')
  }
  const CalcInOut = (data, kodst) => {
    let incomeCount = data.filter(el => el.napr == 1 && el.kodstdis == kodst).length
    let outgoingCount = data.filter(el => el.napr == 2 && el.kodstdis == kodst).length
    return {incomeCount, outgoingCount}
  }
  const SetFiltered = (row, data) => { 
    let filt = false
    data.map(m => (filt = row.StationCode == m.kodstdis ? true : filt  )) 
    return filt
  }
  const FilteredMainData = (data) => {
    const origin = maindata.serverdata.datamain
    const currow = origin.filter(el => el.StationCode == data[0].kodstdis)
    if (api.isNotEmptyArr(currow)) SetCurentRow({})
    let temp = origin.filter(el => SetFiltered(el, data))
    //temp.map((el) => {
    //  const {inv, outv} = CalcInOut(data, el.StationCode)
   // })
    const resul = temp.reduce((res, cur) => {
      const {incomeCount, outgoingCount} = CalcInOut(data, cur.StationCode)
      return [...res, {...cur, incomeCount, outgoingCount }]
    }, [])
    SetMainList(resul)
    
  }
  const CheckMainDataST = (row) => {
    const origin = maindata.serverdata.datamain
    const currow = origin.filter(el => el.StationCode == row.kodstdis)
    if (!api.isEmpty(currow)) {
      if (!(currow.incomeCount == 0 && currow.outgoingCount == 0)) {
        return true 
      }
     }  
    return false
  }
  const handleHide = () => { 
    SetHide(hide + 1)
    if (hide == 2) return SetHide(0)
    return hide
  }
  const handleMinMax = (sblst) => {
    //const fdat = n => n.datop ? new Date(n.datop) : null
    //const minper = R.reduce(R.minBy(fdat), Infinity, sublist)
    //const maxper = R.reduce(R.maxBy(fdat), 0, sublist)
    let minper = null
    let maxper = null
    if (api.isNotEmptyArr(sblst)) {
      const dates = sblst.reduce((adat, e) => e && e.datop ? [...adat, new Date(e.datop)] : adat, [])
      maxper = new Date(Math.max(...dates));
      minper = new Date(Math.min(...dates));
    }
    return {minper,maxper}
  }
  const handleFilterAnswer = (answer, listFilter,clear, showm = true ) => {  
    
    SetAutoclearFilter(false)
    SetShowFilter({open : false,title:'Фильтр по полям', mess : ""})
    if (answer == false) return
    
    let check = false
    R.keys(listFilter).map(key => check = (listFilter[key] !== null ? true : check))
    if (!check||clear) {
     /* SetMainList(maindata.serverdata.datamain)
      SetSubList(maindata.serverdata.subdata)
      SetOriginSubList(maindata.serverdata.subdata)*/
      dispatch(getServerDataRedux(apiDataUrl, true, { datafilter: filter }, thisMock, main_data, 'FETCH_MAIN_DATA', main_data_empty))
      SetCurentRow({})
      if (!check) Setsubfilter(false)
      if (showm)
        messageWin("Фильтр очищен.");
    }
    else {
     /* let templist = [...maindata.serverdata.subdata]
      R.keys(listFilter).map(key => {
        if (listFilter[key] !== null)
          if (api.isNotEmptyArr(listFilter[key]) && key !== 'date') {
            let arrfilter = []
            listFilter[key].map(k => {
              let tmplist = templist.filter(row => {
                let res
                if (typeof row[key] === 'number') {
                  if (key == 'napr') {
                    if (listFilter[key].length == 2)
                      res = true
                    else {
                      if (listFilter[key][0] == "Прием")
                        res = row[key] == 1
                      else
                        res = row[key] == 2
                    }
                  }
                  else
                    res = row[key] == Number(k)
                }
                if (typeof row[key] === 'string')
                  res = row[key].toString().indexOf(k) !== -1
                if (key == 'activ') {
                  const curList = R.find(R.propEq('name', 'Activ'))(pick).rows
                  let rowactiv = R.find(R.propEq('title', k))(curList)
                  const { pk_id } = rowactiv
                  const kodpol = pk_id
                  if (row['napr'] == 1)
                    res = (row['kodpol'] == kodpol)
                  else if (row['napr'] == 2)
                    res = (row['kodotpr'] == kodpol)
                }
                if (key == 'stancprim') {
                  const curList = R.find(R.propEq('name', 'stancPrim'))(pick).rows
                  let rowprim = R.find(R.propEq('title', k))(curList)
                  const { id } = rowprim
                  const kodstnazn = id
                  res = (row['kodstnazn'] == kodstnazn)
                }
                if (key == 'stdis') {
                  const std = k.split(' ')
                  res = row['kodstdis'].toString().indexOf(std[0]) !== -1
                }
                if (key == 'sostav') {
                  const sostav = k.split(' ')
                  res = row['indp'].toString().indexOf(sostav[0]) !== -1
                }
                if (key == 'marshrut') {
                  const marsh = k.split(' ')
                  res = row['indp'].toString().indexOf(marsh[0]) !== -1
                }
                return (res)
              })
              arrfilter = [...arrfilter, ...tmplist]
            })
            templist = [...arrfilter]
          }
          else
            templist = templist.filter(row => {
              let res
              if (typeof row[key] === 'number') {
                res = row[key] == Number(listFilter[key])
              }
             
              if (typeof row[key] === 'string') {
                res = row[key].toString().indexOf(listFilter[key]) !== -1
              }
            
              if (key == 'st' && Number(listFilter[key]) == 1) {
                res = CheckMainDataST(row, Number(listFilter[key]))
              }

              if (key == 'date') {
                const k = listFilter[key]
                res = new Date(row['datop']) > new Date(k[0]) && new Date(row['datop']) < new Date(k[1])
              }

              return (res)
            })
      })
      
      if (api.isNotEmptyArr(templist))
        FilteredMainData(templist)
      else {
        SetMainList([])
        SetCurentRow({})
      }
        SetSubList(templist)
        SetOriginSubList(templist)
       */
      R.keys(listFilter).map(key => {
        if (listFilter[key] !== null)
          if (api.isNotEmptyArr(listFilter[key])) {
            let arrfilter = []
            listFilter[key] = listFilter[key].reduce((res, el) => {
              let cutel = null
              if (key == 'sostav' || key == 'marshrut')
                cutel = el.split(' ')[0]
              else cutel = el
              return [...res, cutel]
            }, [])
             
          }
      }
      )
        Setsubfilter(true)
        console.log('filt', listFilter)
        SetFilter(listFilter)
        dispatch(getServerDataRedux(apiDataUrl, true, { datafilter: listFilter }, thisMock, main_data2, 'FETCH_MAIN_DATA', main_data_empty))
        Setdeselectgrid(!deselectgrid)
        SetFocus(true)
        SetCurentRow({})
      //SetMainFilter(listFilter)
      //console.log('mainfilter', mainfilter)
        //SetCurentRow({})
       //if (showm)
       //  messageWin("Данные отфильтрованы ...");

     }

  }
  
  const handleClearFilter = () => {
    handleFilterAnswer(true,filter,true,true)
    SetAutoclearFilter(true)
   // messageWin("Фильтр очищен.");
  }
  const onHandleMessage = (mess) => {
    messageWin(mess)
  }
  const NoCurData = (data) => {
    if (!api.isNotEmptyArr(data)) return []
    if (api.isEmpty(curentRow)) return data
    return data.filter(el=>el.ID != curentRow.ID)
  }
  const handleSearchStation = (station) => {
    const rowidx = R.findIndex(R.propEq('StationCode', station.code))(mainlist)
    SetCurentIdxRow(rowidx)
  }

 return (
    <Fragment>
      <Style>
         {themeCss}
      </Style>
      <Style>
         {globalCss}
      </Style>
     <div className='App'>
      {!api.isNotEmptyArr(configApp) && <api.Spinner />}
      {api.isNotEmptyArr(configApp) && maindata.serverdata && maindata.serverdata.subdata && <Fragment>
         <div style={{position: 'absolute0',top:0,left:0, width:'100%'}}>
          <ShowAppHeader
            config={{ iconsApp, configApp, name: 'header' }}
            viewmode={null}
            messageSimple={() => ("Простое сообщение")}
            messagetitle={" Шаблон клиенского приложения (единый интерфейс) ."}
            alertSimple={() => alertWin("info", "Расширенная инфа о сайте")}
            errorSimple={() => alertWin("error", "Вывод ошибки")}
            nameNsi={"Визуализация подходов грузов"}
          />
          {SHOW_TOOL_BAR && <ShowAppToolbar
             config={{ iconsApp, configApp, name: 'toolsbar' }}
             filtered={subfilter}
             handleSeek={handleSeek}
             onColumnFilter={handleColumnFilter}
             onClearFilter={handleClearFilter}
             onHide={handleHide}
             focus={focus}
             server={{
               db, tree, StationCode: !api.isEmpty(curentRow) && curentRow.StationCode ? curentRow.StationCode : null,
               apiRepUrl
             }}
             filter={filter}
            //onSaveData={handleSaveData}
            //onDeleteRow={handleDeleteRow}
            //onInsertRow={handleInsertRow}
             onGetReport={handleGetReport}
             SetFullTable={(flg) => Setfulltable(flg)}
             SetFullMap={(flg) => Setfullmap(flg)}
             setShowAllMarcers={(flg)=>SetShowAllMarcers(flg)}
             fulltable={hide}
             fullmap={fullmap}
             pick={pick}
             mainfilter={mainfilter}
             showAllMarcers = {showAllMarcers}
            //onColumnFilterLoc = {this.handleColumnFilterLoc.bind(this)}
          />}
        </div>  
        {SHOW_LEFT_SIDE_BAR && <div style={{/*position: 'absolute0', top: '15vh', left: '1vh',*/ width: '100%' }}>
          <ShowAppSidebar
            config={{ iconsApp, configApp, name: 'left-sidebar' }}
          />
        </div>}
        <div style={{/*position: 'absolute0', top: api.TopPos(), left: '0',*/ width: '100%' }} className={"main-content"}>
           <div className="mainContent" style={{height: api.ContentHeight()}}>
             <div id='azuremap' className={fullmap == false ? "forMap" : "forMapFull"} >
               <ShowAzureMap
                 data={NoCurData(mainlist)}
                 current={api.isNotEmptyArr(curentRow) ? curentRow[0] : curentRow}
                 subdata={sublist}
                 originsubdata={originsublist}
                 fullmap={fullmap}
                 SetFullMap={(flg) => Setfullmap(flg)}
                 showAllMarcers={showAllMarcers}
                 deffilter={mainfilter}
                 onSearchStation={handleSearchStation}
                 //onUpdCoordinates={handleUpdCoordinates}
               />
          </div> 
             {<div id='datagrid' style={{height: api.ContentHeight()}} className={hide == 0 ? "forGrid" : hide == 1 ? "mapFull" : "forGridFull"}>
               <div className="forGridMaster">
                 <ShowMasterGrid
                   name='Main_data'
                   PrimaryId='ID'
                   columnsgrid={columnsMainData}
                   data={mainlist}
                   curidxrow={curentIdxRow}
                   maxwidth={2}
                   readonly={false}
                   paddingBottom={true}
                   //minHeight={api.GridHeight()}
                   maxHeight={api.GridHeight()}
                   currentRow={curentRow}
                   masterGrid={true}
                   deselect={deselectgrid}
                   onHandleMess={onHandleMessage}
                   onSaveData={onHandleSave}
                   //onHandleUpdateGrid={onHandleUpdateGrid}
                   //onHandleDelete={onHandleDelete}
                   //onHandleAdd={onHandleAdd}
                   onCurRow={handleCurRow}
                   onMessage={(mess) => dialogWin(1, 'Внимание', mess, true)
                   }
                 />
               </div>
               <div className="forGridDetail">
                 <ShowGrid
                   name='Sub_data'
                   PrimaryId='ID'
                   columnsgrid={columnsSubData}
                   data={sublist}
                   maxwidth={2}
                   readonly={false}
                   //minHeight={api.GridHeight()}
                   maxHeight={api.GridHeight()}
                   masterGrid={false}
                   currentRow={curentSubRow}
                   
                   onHandleMess={onHandleMessage}
                   onSaveData={onHandleSave}
                   onSubCurRow={handleSubCurRow}
                   
                   onMessage={(mess) => dialogWin(1, 'Внимание', mess, true)
                   }
                 />
               </div>
             </div>}
         </div> 
        </div> 
        {SHOW_FOOTHER && <div style={{ position: 'absolute0', bottom: 0, left: 0, width: '100%' }}>
          <ShowAppFooter
            config={{iconsApp,configApp,name:'footer'}}
          />
        </div>}  
       </Fragment>}
     </div>
     <ShowFilter
                open={showFilter.open}
                title={showFilter.title}
                datefilter={datefilter}
                columns={columnsFilter}
                pick={pick}
                cleafiltr={autoclearFilter}
                deffilter={mainfilter}
                onAnswer={handleFilterAnswer}
                onAnswerClear={handleClearFilter}
                subdata={sublist}
                minmaxper={minmaxper}
              />
    </Fragment>
  );
}

export default App;
